import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DialogOnboardingPromoComponent } from "../common/dialog-onboarding-promo/dialog-onboarding-promo.component";
import { MarkPromoFlagSeenRequest, UserPromoFlagsService } from "src/swagger/api.client.generated";

const COMMUNITY_PROMO_FLAG_KEY = "CommunityPromo";

/**
 * Shows the "welcome to flip*" one-on-one onboarding promo (FLIP-144) at most once per
 * user: immediately after a new user finishes onboarding, or on an already-registered
 * user's next login/app open. Called from both onboarding-flow.component.ts (new users)
 * and app.component.ts (existing users).
 *
 * "Seen" is tracked server-side in UserPromoFlags (UserPromoFlagsController) rather than
 * localStorage, so it survives a logout/re-login - UserPromoFlags is a generic per-user
 * FlagKey table, so any future one-time promo/modal reuses this same service with a new key.
 */
@Injectable({ providedIn: "root" })
export class CommunityPromoModalService {
  constructor(
    private dialog: MatDialog,
    private userPromoFlagsService: UserPromoFlagsService
  ) {}

  maybeShow(): void {
    this.userPromoFlagsService.getSeenFlagKeys().subscribe({
      next: (response) => {
        const seenFlagKeys = response.responseData ?? [];
        if (seenFlagKeys.includes(COMMUNITY_PROMO_FLAG_KEY)) {
          return;
        }
        this.userPromoFlagsService
          .markFlagSeen(new MarkPromoFlagSeenRequest({ flagKey: COMMUNITY_PROMO_FLAG_KEY }))
          .subscribe();
        this.dialog.open(DialogOnboardingPromoComponent, {
          panelClass: "base-modal-panel",
          backdropClass: "base-modal-backdrop",
        });
      },
      // Non-critical: if the seen-flags check fails, skip showing the promo this time
      // rather than risk a broken check making it show on every app open.
      error: () => {},
    });
  }
}
